
export const initialValues = {
  settingModuleId: undefined,
  emailIsApplicable: 0,
  whatsappIsApplicable: 0,
  smsIsApplicable: 0,
  activeStatus: 1,

}